import { cn } from 'src/lib/utils';
import { portalDs } from 'src/components/portal-design-system';
import { LogMonitoringSection } from '../components/log-monitoring-section';

const LogMonitoringTab = () => (
  <div className={cn(portalDs.page, 'h-full overflow-y-auto px-6 py-8 sm:px-10')}>
    <LogMonitoringSection />
  </div>
);

export default LogMonitoringTab;
